export default "https://assets.egbcdn.net/assets/packs/_/images/app/apk/apk-5-96b1cfe81afeda4326de85e90098cfe5.png";